module.exports = __webpack_public_path__ + "img/employee-3.babd1747.jpeg";